__turbopack_context__.v({
  "arrow": "Button-module__3dJGfa__arrow",
  "label": "Button-module__3dJGfa__label",
  "main": "Button-module__3dJGfa__main",
  "outlined": "Button-module__3dJGfa__outlined",
  "slim": "Button-module__3dJGfa__slim",
  "spacer": "Button-module__3dJGfa__spacer",
  "withArrow": "Button-module__3dJGfa__withArrow",
  "withArrowAtMd": "Button-module__3dJGfa__withArrowAtMd",
});
